import React, { useEffect } from "react";
import Modal from "../../Components/Modal/Modal";
import { Button, Textarea } from "../../Components/StyledComponents";
import BannerImage from "./BannerImage";
import './Setting.scss';
import ReactDragListView from 'react-drag-listview';
import axios from "axios";
import { alertRef } from "../../App";

const Setting = () => {
    const [ intro, setIntro ] = React.useState('')//배너 한줄 설명
    const [ tempIntro, setTempIntro ] = React.useState('');//한줄 설명 임시 저장
    const [ isIntroModify, setIsIntroModify ] = React.useState(false)//한줄 설명 수정 여부
    const [ images, setImages ] = React.useState([])//배너 이미지 목록
    const [ isImageModify, setIsImageModify ] = React.useState(false)//배너 이미지 수정 여부

    const imageModalRef = React.useRef(null) //이미지 추가 모달

    useEffect(() => {
        getIntro()
    },[])

    //한줄 설명 get
    const getIntro = () => {
        axios.get('/api/tablet/intro')
        .then((data) => {
            setIntro(data.data.TabletInfo.Intro)
            getImages()
        })
    }

    //한줄 설명 수정
    const patchIntro = () => {
        axios.patch('/api/tablet/intro',{ Intro : intro })
        .then((data) => {
            alertRef.current.showAlert({ title : `저장되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();} })
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();} })
        })
    }

    //배너 이미지 get
    const getImages = () => {
        axios.get('/api/tablet/banner')
        .then((data) => {
            setImages(data.data.TabletInfo.BannerImages)
        })
    }

    //Image modal hide
    const hideModal = () => {
        imageModalRef.current.closeModal()
    }

    //배너 이미지 삭제
    const deleteImage = (name) => {
        axios.delete('/api/tablet/banner/' + name)
        .then((data) => {
            alertRef.current.showAlert({ title : `이미지가 삭제되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();getImages()} })
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();} })
        })
    }

    //배너 이미지 순서 변경
    const patchImage = () => {
        axios.patch('/api/tablet/banner',{ Images : images })
        .then(() => {
            setIsImageModify(false)
            alertRef.current.showAlert({ title : `이미지 순서가 변경되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();getImages()} })
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert();} })
        })
    }

    //이미지 순서 변경 drag prop
    const dragProps = {
        onDragEnd(fromIndex, toIndex) {
          if(!isImageModify) return;
          const data = [...images];
          const item = data.splice(fromIndex, 1)[0];
          data.splice(toIndex, 0, item);
          setImages([...data]);
        },
        nodeSelector: 'li',
        handleSelector: 'div',
        lineClassName : 'line',
    };

    //수정 전 한줄 설명 임시 저장 및 복구
    const toggleIntro = () => {
        if( isIntroModify){
            setIntro(tempIntro)
        }else {
            setTempIntro(intro)
        }
        setIsIntroModify(old => !old)
    }

    return (
        <div className='wrapper'>
            <div className='header-row'>
                <p className='header-text'>태블릿 설정</p>
            </div>
            
            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>배너 한줄설명</p>
                        <p className='info-sub-title'>테블릿에 표시될 매장 안내사항이나 소개, 포인트 규칙등을 적어주세요.</p>
                    </div>
                    <div className='row'>
                        <Button variant='sub' small style={{ width : 88 }} onClick={() => toggleIntro()}>
                            { isIntroModify ? '취소하기' : '수정하기'}
                        </Button>
                        {
                            isIntroModify && 
                            <Button variant='main' small style={{ width : 88, marginLeft : 8 }} onClick={() => {setIsIntroModify(old => !old); patchIntro() }}>
                                저장하기
                            </Button>
                        }
                    </div>
                </div>

                <div className='header-divider' ></div>

                <Textarea
                    disabled={!isIntroModify}
                    value={intro}
                    onChange={(e) => setIntro(e.target.value)} 
                    style={{ width : '100%', height : 80 }}
                    placeholder='예) 1000P 이상부터 사용가능합니다.'
                />
            </div>

            <div className='info-box'>
                <div className='row between'>
                    <div>
                        <p className='info-box-title'>배너 이미지</p>
                        <p className='info-sub-title'>테블릿 배너에 들어갈 이미지를 설정해주세요.</p>
                    </div>
                    <div className='row'>
                        <Button variant='outline' small style={{ width : 88, marginRight : 8 }} onClick={() => imageModalRef.current.openModal()}>
                            이미지 추가
                        </Button>
                        <Button variant='sub' small style={{ width : 88 }} onClick={() => setIsImageModify( old => !old )}>
                            { isImageModify ? '취소하기' : '순서변경'}
                        </Button>
                        {
                            isImageModify &&
                            <Button variant='main' small style={{ width : 88, marginLeft : 8 }} onClick={() => patchImage()}>
                                저장하기
                            </Button>
                        }
                    </div>
                </div>

                <div className="image-box">
                    <ReactDragListView {...dragProps}>
                        <ol style={{ margin : 0 , padding : 0, marginTop : 32 }}>
                            {
                                images.map((data,i) => {
                                    return (
                                        <li key={i}>
                                            <div className="row between" style={{ marginBottom : 16 }}>
                                                <div className="row">
                                                    <p className='move-icon' style={{ width : isImageModify ? 64 : 0, transition : 'all', transitionDuration : '0.2s' }}>
                                                        <img src={require('../../aseets/icons/menu-drag.svg').default} style={{ width : 24, height : 24, pointerEvents : 'none' }} />
                                                    </p>
                                                    <img src={"https://cdn.syrupfriends.com/Images/Banner/" + data} style={{ width : 180, height : 94 }}/>
                                                </div>
                                                <button
                                                    className='remove-btn'
                                                    onClick={() => 
                                                        alertRef.current.showAlert(
                                                            { title : `배너 이미지를 삭제 하시겠습니까?`, 
                                                            subWarnTitle : '',
                                                            isConfirm : true, confirmText : '삭제하기',
                                                            isCancel : true,
                                                            cancelText : '취소',
                                                            onConfirm : () => {alertRef.current.hideAlert();deleteImage(data)} })
                                                            }>
                                                    <img src={require('../../aseets/icons/delete.svg').default} style={{ width : 24, height :24, marginRight : 4 }} />
                                                    삭제하기
                                                </button>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ol>
                    </ReactDragListView>
                </div>
            </div>

            {/* 이미지 추가 모달 */}
            <Modal ref={imageModalRef} contentContainer={{ width : 500 }} isHeader title="배너 이미지 설정">
                <BannerImage close={hideModal} get={getImages}/>
            </Modal>
        </div>
    )
}

export default Setting